import { useContext } from 'react';
import { EWIPDashboardScreenContext } from '../DashboardProvider';
import { Card, CircularProgress, Grid, Hidden, Typography } from '@material-ui/core';
import { Bar, BarChart, CartesianGrid, Cell, LabelList, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { WipNoRecord, WipScreenLoader } from './wipDash-Loader';

export const WipDashboardReturnReason = ({ classes, onChartClickHandler }) => {
    const { state, array, handleArray, width } = useContext(EWIPDashboardScreenContext);

    return (
        <>
            {state.showReturnReasonLoader ? (
                <div className="wip-dash-Card">
                    <WipScreenLoader />
                </div>
            ) : (
                <Card className="wip-dash-Card">
                    <Hidden only={['xs']}>
                        <Grid container justifyContent="space-between">
                            <Grid item xs={12} sm={8} lg={8}>
                                <Typography vraient="h5" color="secondary" className="dashHeading">
                                    Return Reason By Workflow ({!array?.byTimeBranch ? 'All Branch' : array?.byTimeBranch})
                                </Typography>
                            </Grid>
                            <Grid item xs={12} sm={4} lg={4}>
                                <div style={{ float: 'right', marginRight: 40 }}>
                                    <select onChange={handleArray} className="selectclass" value={array.workFlowRR}>
                                        {state?.workflowData.map((j, i) => (
                                            <option key={i} value={j.name}>
                                                {j.name}{' '}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>
                    <Hidden only={['sm', 'md', 'lg', 'xl']}>
                        <Grid container justifyContent="space-between">
                            <Grid item xs={12} sm={8} md={8} lg={10}>
                                <Typography variant="h7" color="secondary" style={{ fontWeight: 600 }}>
                                    <Typography vraient="h5" color="secondary" className="dashHeading">
                                        Return Reason By Workflow ({!array?.byTimeBranch ? 'All Branch' : array?.byTimeBranch})
                                    </Typography>
                                </Typography>
                            </Grid>
                            <Grid item xs>
                                <div
                                    style={{
                                        margin: '0px 20px',
                                        textAlign: 'left'
                                    }}
                                >
                                    <span className="lableFont">Workflow</span>
                                    <select onChange={handleArray} className="selectclass" value={array.workFlowRR}>
                                        {state?.workflowData.map((j, i) => (
                                            <option key={i} value={j.name}>
                                                {j.name}{' '}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </Grid>
                        </Grid>
                    </Hidden>

                    <div className="workflowChart">
                        {array.workflowReturnReasonArray.length > 0 ? (
                            <ResponsiveContainer>
                                <BarChart
                                    data={array.workflowReturnReasonArray}
                                    width={300}
                                    margin={{
                                        top: 20,
                                        right: width >= 600 ? 20 : 10,
                                        left: width >= 600 ? -8 : -30,
                                        bottom: width >= 600 ? 0 : 10
                                    }}
                                    // contentStyle={{ background: 'rgba(0,0,0,0.6)' }}
                                >
                                    <CartesianGrid strokeDasharray="3 3" />
                                    <XAxis
                                        dataKey="workflow"
                                        verticalAnchor="start"
                                        allowDataOverflow={false}
                                        interval={0}
                                        // dy={-5}
                                        // angle={width >= 600 ? '0' : '-20'}
                                        style={{
                                            fontSize: 12,
                                            fontWeight: 700
                                        }}
                                    >
                                        {/* <Label value="Pages of my website" offset={-4} position="insideBottom" /> */}
                                    </XAxis>
                                    <YAxis style={{ fontSize: 12 }} />
                                    <Tooltip
                                        contentStyle={{
                                            background: 'rgba(0,0,0,0.8)',
                                            color: 'white',
                                            fontSize: 12,
                                            fontWeight: 700
                                        }}
                                        position={{ x: 30, y: 20 }}
                                    />
                                    {/* <Legend height={10} /> */}

                                    {array?.keys?.map((m, i) => {
                                        let color = state?.returnReasonColors.find((n) => n.rr === m);
                                        return (
                                            m !== 'name' &&
                                            m !== 'workflowID' &&
                                            m !== 'workflow' && (
                                                <Bar dataKey={m} fill={color.color} barSize={width >= 600 ? 40 : 15} layout="vertical" height={20}>
                                                    <LabelList dataKey={m} position="top" />
                                                    {array.workflowReturnReasonArray.map((entry, index) => {
                                                        return (
                                                            <Cell
                                                                style={{ cursor: 'pointer' }}
                                                                onClick={() =>
                                                                    onChartClickHandler(
                                                                        {
                                                                            workflowID: entry.workflowID,
                                                                            returnReason: m,
                                                                            bn: entry.name
                                                                        },
                                                                        true
                                                                    )
                                                                }
                                                            />
                                                        );
                                                    })}
                                                </Bar>
                                            )
                                        );
                                    })}
                                </BarChart>
                            </ResponsiveContainer>
                        ) : (
                            // <Grid container justifyContent="center" alignContent="center">
                            <div className="wip-dash-Card">
                                <WipNoRecord />
                            </div>
                            // </Grid>
                        )}
                    </div>
                </Card>
            )}
        </>
    );
};
